import { render, staticRenderFns } from "./SpreadViewerSourceOptions.vue?vue&type=template&id=5797ee8c"
import script from "./SpreadViewerSourceOptions.vue?vue&type=script&lang=js"
export * from "./SpreadViewerSourceOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5797ee8c')) {
      api.createRecord('5797ee8c', component.options)
    } else {
      api.reload('5797ee8c', component.options)
    }
    module.hot.accept("./SpreadViewerSourceOptions.vue?vue&type=template&id=5797ee8c", function () {
      api.rerender('5797ee8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/spread-viewer-options/SpreadViewerSourceOptions.vue"
export default component.exports